export default __webpack_public_path__ + "static/media/Gilroy-Thin.f7dc9e6f.otf";